// extracted by mini-css-extract-plugin
export default {"drawer":"UserDrawer_drawer__BQFZ+","drawerChildren":"UserDrawer_drawerChildren__3SD3x","drawerTitle":"UserDrawer_drawerTitle__5R1F1","drawerFooter":"UserDrawer_drawerFooter__z4l8s"};